import { Group } from "@models/ISchema";

export const getGroupLabel = (group: Group, hasCompletedCode = false): string => {
  return `${(hasCompletedCode ? group?.code : group?.label) ?? ""}${
    group?.course?.name ? ` ${group?.course?.name}` : ""
  }`;
};
